angular.module('st')
    .controller('crewardsPersonalInfoController', [
        '$rootScope', '$scope', '$http', '$sce', '$timeout','$location',
        function ($rootScope, $scope, $http, $sce, $timeout, $location) {
            var ctrl = this;
            
            $scope.States = {
                "AL": "Alabama",
                "AK": "Alaska",
                "AZ": "Arizona",
                "AR": "Arkansas",
                "CA": "California",
                "CO": "Colorado",
                "CT": "Connecticut",
                "DE": "Delaware",
                "DC": "District Of Columbia",
                "FL": "Florida",
                "GA": "Georgia",
                "HI": "Hawaii",
                "ID": "Idaho",
                "IL": "Illinois",
                "IN": "Indiana",
                "IA": "Iowa",
                "KS": "Kansas",
                "KY": "Kentucky",
                "LA": "Louisiana",
                "ME": "Maine",
                "MD": "Maryland",
                "MA": "Massachusetts",
                "MI": "Michigan",
                "MN": "Minnesota",
                "MS": "Mississippi",
                "MO": "Missouri",
                "MT": "Montana",
                "NE": "Nebraska",
                "NV": "Nevada",
                "NH": "New Hampshire",
                "NJ": "New Jersey",
                "NM": "New Mexico",
                "NY": "New York",
                "NC": "North Carolina",
                "ND": "North Dakota",
                "OH": "Ohio",
                "OK": "Oklahoma",
                "OR": "Oregon",
                "PA": "Pennsylvania",
                "RI": "Rhode Island",
                "SC": "South Carolina",
                "SD": "South Dakota",
                "TN": "Tennessee",
                "TX": "Texas",
                "UT": "Utah",
                "VT": "Vermont",
                "VA": "Virginia",
                "WA": "Washington",
                "WV": "West Virginia",
                "WI": "Wisconsin",
                "WY": "Wyoming"
            }
            $scope.formFeedback = '';
            $scope.processing = false;
            $scope.model = {};

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const forgotPassword = urlParams.get('updatepassword')

            if (forgotPassword) {
                $('#update-password-modal').modal({ backdrop: 'static', keyboard: false, show: true });
            }

            ctrl.IsFieldInvalid = function(field) {
                return field.$invalid && (field.$touched || $scope.frm.$submitted);
            }
            
            ctrl.SubmitForm = function () {
                if (!$scope.frm.$valid) {
                    var position = ($('.form-container .ng-invalid').first().offset().top) - 150;
                    $('html, body').animate({
                        scrollTop: position
                    },500);
                    return;
                }
                $scope.processing = true;
                $scope.formFeedback = 'Processing...';
                grecaptcha.ready(function() { 
                    grecaptcha.execute($('#captcha-site-key').val(), {action: 'crewards_personal_info'}).then(function(token) { 
                        $scope.model.captchaToken = token;
                        $http.post("/rpc/membership/account/personal-info", $scope.model)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.formFeedback = '';
                                    $scope.processing = false;
                                } else {
                                    // vista error
                                    $scope.processing = false;
                                    $scope.formFeedback = 'Error: ' + data.data.Message;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.processing = false;
                                $scope.formFeedback = 'Error occurred while trying to submit the form.'
                            })
                    }); 
                }); 
            };

            ctrl.UpdatePasswordSubmit = function (form) {
                $scope.updatePasswordClicked = true;
                $scope.updatePasswordProcessing = true;
                $scope.updatePasswordFeedback = 'Updating password...';
                
                grecaptcha.ready(function() { 
                    grecaptcha.execute($('#captcha-site-key').val(), {action: 'crewards_update_password'}).then(function(token) { 
                        $scope.updatePasswordModel.captchaToken = token;
                        $http.post("/rpc/membership/update-password", $scope.updatePasswordModel)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    // success
                                    $scope.updatePasswordProcessing = false;
                                    $scope.updatePasswordFeedback = '';
                                    $scope.updatePasswordScreen = 'message';
                                } else {
                                    // vista error
                                    var msg = data.data.Message;
                                    $scope.updatePasswordProcessing = false;
                                    $scope.updatePasswordFeedback = msg;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.updatePasswordProcessing = false;
                                $scope.updatePasswordFeedback = 'Error occurred while trying to update the password.'
                            })
                    }); 
                }); 
            }

            ctrl.CloseModal = function () {                
                $timeout(function () {
                    $scope.updatePasswordProcessing = false;
                    $scope.updatePasswordClicked = false;
                    $scope.updatePasswordFeedback = '';
                    $scope.updatePasswordModel.CurrentPassword = '';
                    $scope.updatePasswordModel.NewPassword = '';
                    $scope.updatePasswordModel.ConfirmPassword = '';
                    $scope.updatepwform.$setPristine(true);
                    $scope.updatepwform.$setUntouched(true);
                    $scope.updatePasswordScreen = 'form';
                }, 1000);
            }

            ctrl.IsFieldInvalid = function (field, form) {
                return field.$invalid && (field.$touched || form.$submitted);
            }
        }
    ]);
